import request from "@/utils/request"

// 登录方法
export function login(data) {
  // const data = {
  //   username,
  //   password,
  //   code,
  //   uuid,
  //   smsCode,
  //   type,
  //   shopRegisterNumber,
  // };
  return request({
    url: "/login",
    headers: {
      isToken: false,
      NotStoreId: true
    },
    method: "post",
    data
  })
}

// 注册方法
export function register(data) {
  return request({
    url: "/register",
    headers: {
      isToken: false,
      NotStoreId: true
    },
    method: "post",
    data: data
  })
}

// 获取用户详细信息
export function getInfo() {
  return request({
    url: "/getInfo",
    method: "get",
    headers: {
      NotStoreId: true
    }
  })
}

// 退出方法
export function logout() {
  return request({
    url: "/logout",
    method: "post"
  })
}

// 获取验证码
export function getCodeImg() {
  return request({
    url: "/captchaImage",
    headers: {
      isToken: false,
      NotStoreId: true
    },
    method: "get",
    timeout: 20000
  })
}
